<template>
  <div>
    <span
      v-if="
        types_of_entries_ids.length > 0 ||
        users_ids.length > 0 ||
        provider_ids.length > 0 ||
        finance_client_ids.length > 0 ||
        finance_configuration_document_types_ids.length > 0 ||
        finance_configuration_payment_methods_ids.length > 0 ||
        finance_configuration_category_ids.length > 0 ||
        finance_configuration_profit_cost_center_ids.length > 0 ||
        finance_configuration_tag_ids.length > 0 ||
        cost_types_ids.length > 0 ||
        cost_appropriations_ids.length > 0
      "
    >
      Filtros:
    </span>
    <span v-if="types_of_entries_ids.length > 0">
      <span
        class="text-uppercase mr-1 p-1 text-eleven"
        v-if="types_of_entries_ids.includes('PAGOS')"
        >pagos
      </span>
      <span
        class="text-uppercase mr-1 p-1 text-eleven"
        v-if="types_of_entries_ids.includes('CONTAS_A_PAGAR')"
        >contas a pagar.</span
      >
      <span
        class="text-uppercase mr-1 p-1 text-eleven"
        v-if="types_of_entries_ids.includes('CONTAS_A_PAGAR_ATRASADAS')"
        >contas a pagar atrasados.</span
      >
      <span
        class="text-uppercase mr-1 p-1 text-eleven"
        v-if="types_of_entries_ids.includes('DESCONSIDERAR_TRANSFERENCIAS')"
        >desconsiderar transferências.</span
      >
      <span
        class="text-uppercase mr-1 p-1 text-eleven"
        v-if="types_of_entries_ids.includes('RECEBIDOS')"
        >recebidos.</span
      >
      <span
        class="text-uppercase mr-1 p-1 text-eleven"
        v-if="types_of_entries_ids.includes('CONTAS_A_RECEBER')"
        >contas a receber.</span
      >
      <span
        class="text-uppercase mr-1 p-1 text-eleven"
        v-if="types_of_entries_ids.includes('CONTAS_A_RECEBER_ATRASADAS')"
        >contas a receber atrasados.</span
      >
    </span>
    <span
      class="text-uppercase mr-1 p-1 text-eleven"
      v-if="users_ids.length > 0"
      >usuários.</span
    >
    <span
      class="text-uppercase mr-1 p-1 text-eleven"
      v-if="provider_ids.length > 0"
      >fornecedors.</span
    >
    <span
      class="text-uppercase mr-1 p-1 text-eleven"
      v-if="finance_client_ids.length > 0"
      >clientes.</span
    >
    <span
      class="text-uppercase mr-1 p-1 text-eleven"
      v-if="finance_configuration_document_types_ids.length > 0"
      >tipos de documentos.</span
    >
    <span
      class="text-uppercase mr-1 p-1 text-eleven"
      v-if="finance_configuration_payment_methods_ids.length > 0"
      >formas de pagamento.</span
    >
    <span
      class="text-uppercase mr-1 p-1 text-eleven"
      v-if="finance_configuration_category_ids.length > 0"
      >usuários.</span
    >
    <span
      class="text-uppercase mr-1 p-1 text-eleven"
      v-if="finance_configuration_profit_cost_center_ids.length > 0"
      >centro de custo/lucro.</span
    >
    <span
      class="text-uppercase mr-1 p-1 text-eleven"
      v-if="finance_configuration_tag_ids.length > 0"
      >tags.</span
    >
    <span
      class="text-uppercase mr-1 p-1 text-eleven"
      v-if="cost_types_ids.length > 0"
      >tipo de custo nível de produção.</span
    >
    <span
      class="text-uppercase mr-1 p-1 text-eleven"
      v-if="cost_appropriations_ids.length > 0"
      >tipo de custo de apropriação do produto.</span
    >
  </div>
</template>

<script>
export default {
  name: "ListFilters",
  props: {
    types_of_entries_ids: Array,
    users_ids: Array,
    provider_ids: Array,
    finance_client_ids: Array,
    finance_configuration_document_types_ids: Array,
    finance_configuration_payment_methods_ids: Array,
    finance_configuration_category_ids: Array,
    finance_configuration_profit_cost_center_ids: Array,
    finance_configuration_tag_ids: Array,
    cost_types_ids: Array,
    cost_appropriations_ids: Array,
  },
};
</script>
